/*
 * @author       David Loehr (david.loehr@zumper.com)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { GCLID_LOCAL_STORAGE_KEY, MSCLKID_LOCAL_STORAGE_KEY } from '../constants'
import type { LocalStorage } from '../types/LocalStorage'
import { tokenConfig as _tokenConfig } from './addTrackingToLocalStorage'

const tokenConfig = [
  ..._tokenConfig,
  ['gclid', GCLID_LOCAL_STORAGE_KEY, 7],
  ['msclkid', MSCLKID_LOCAL_STORAGE_KEY, 7],
] as const

export function getTrackingFromLocalStorage(localStorage: LocalStorage) {
  const params: Array<readonly [(typeof tokenConfig)[number][0], string]> = []
  for (const [token, storageKey] of tokenConfig) {
    if (storageKey) {
      const value = localStorage.getx(storageKey)
      if (value != null) {
        params.push([token, value])
      }
    }
  }
  return params
}
